import { getAuth } from "firebase/auth";
import { useEffect, useState } from "react";
import GetAllHolidays from "../../../../Controllers/Common/GetAllHolidays";
import GetUser from "../../../../Controllers/Users/GetUser";

export default function HolidaysListingViewModel() {
  const [SchoolID, setSchoolID] = useState("");
  const [IsLoading, setIsLoading] = useState(false);
  const [AuthUser, setAuthUser] = useState();
  const [HolidaysArray, setHolidaysArray] = useState([]);

  useEffect(() => {
    const items = JSON.parse(localStorage.getItem("schoolId"));
    setSchoolID(items);
  }, []);

  useEffect(() => {
    async function fetchData() {
      getAuth().onAuthStateChanged(async (user) => {
        const UserData = await GetUser(user?.uid);
        setAuthUser(UserData);
      });
    }
    fetchData();
  }, []);

  useEffect(() => {
    async function fetchData() {
      setIsLoading(true);
      const HolidaysData = await GetAllHolidays(SchoolID);
      setHolidaysArray(HolidaysData);
      setIsLoading(false);
    }
    fetchData();
  }, [SchoolID]);

  return {
    HolidaysArray,
    IsLoading,
    AuthUser,
  };
}
